/**
 * Get local date key (YYYY-MM-DD) for any UTC timestamp
 * Browser automatically handles timezone conversion, DST, and locale differences
 *
 * @param isoUtcTimestamp - UTC timestamp from API (e.g., "2024-07-07T22:30:00Z")
 * @returns Local date string in YYYY-MM-DD format (e.g., "2024-07-08")
 */
export function getLocalDayKey(isoUtcTimestamp: string): string {
  return new Date(isoUtcTimestamp).toLocaleDateString('sv-SE')
}
